/* Built In Imports */
/* External Imports */
import {
  Box, Flex, Image
} from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';
import Masonry from 'react-masonry-css';
import ReactStars from 'react-rating-stars-component';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/Headings/SectionTitle';
import ContentArea from '@components/Layout/ContentArea';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { EmptyIcon, FilledIcon } from './Icons';

/* Services */
/* Styles */
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

/* Services */

/**
 * Renders the Testimonials component.
 *
 * @param testimonialsObj.testimonialsObj
 * @param {object} testimonialsObj component.
 * @param {string} region - Region of page
 * @param {string} lang - Language of page
 * @param testimonialsObj.region
 * @param testimonialsObj.lang
 * @param testimonialsObj.ratings
 * @param testimonialsObj.sectionContent
 * @returns {ReactElement} Testimonials component.
 */
const Testimonial = ({
  testimonialsObj,
  region,
  lang,
  ratings,
  sectionContent,
}) => {
  const breakpointColumnsObj = {
    default: 3,
    1100: 3,
    980: 2,
    768: 2,
    736: 1,
  };
  return (
    <Box
      pos={'relative'}
      w="auto"
      background="#f9f7f7"
      p={{ md: '70px', base: '30px 15px' }}
    >
      <SectionTitle m titleObj={testimonialsObj?.title[0]} />
      {/* <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 900: 2, 1100: 3 }}> */}
      <Masonry breakpointCols={breakpointColumnsObj} gutter="15px">
        {/* <SimpleGrid
        columns={{ lg: '3', md: 2, base: '1' }}
        spacing="30px"
        spacingY="26px"
        width="100%"
        mx="auto"
      > */}
        {testimonialsObj?.testimonials?.map((data, i) => {
          const emptyImage =
            sectionContent.body[4].sectionContent[1].image.url;
          const filledImage =
            sectionContent.body[4].sectionContent[0].image.url;
          return (
            <Box
              // w={{
              //   lg: 'calc((100% - 52px)/3)',
              //   md: 'calc((100% - 52px)/2)',
              //   base: '100%',
              // }}
              w={{ md: '100%', sm: '100%', base: '100%' }}
              h="auto"
              marginRight="26px"
              padding="29px 28px 28px"
              borderRadius="5px"
              border="solid 1px #dbdbdb"
              background="#ffffff"
              marginBottom="25px"
              maxW={{ lg: '400px', base: '350px' }}
              key={nanoid()}
              mx={{ lg: '0', base: 'auto' }}
              minW={{ lg: '350px', md: '350px', base: '1px' }}
              textAlign="left"
              fontFamily="FedraSansStd-book"
            >
              <Flex>
                {data?.photo?.url && (
                  <Image
                    src={data?.photo?.url}
                    alt={data?.photo?.alt}
                    title={data?.photo?.title}
                    w="64px"
                    height="64px"
                    // pr="15px"
                    m="0"
                    // borderRadius="100%"
                    verticalAlign="middle"
                  // pb="1vw"
                  />
                )}

                {data?.userName && (
                  <Box className="userName" pl="10px">
                    {data?.userName}
                    <Flex
                      alignItems="center"
                      justifyContent="flex-start"
                      flexDir={{ sm: 'row', base: 'column' }}
                    >
                      <Rating
                        region={region}
                        lang={lang}
                        rating={ratings[i]}
                        emptyImage={emptyImage}
                        filledImage={filledImage}
                      />
                      <StructuredTextParser
                        str={render(data.userDescription)}
                        region={region}
                        lang={lang}
                        fontFamily="'FedraSansStd-medium', sans-serif"
                        fontSize="16px"
                        color="##bababa"
                        textAlign="left"
                        className="commentDate"
                      />
                      <style>
                        {`
                          .commentDate{
                            font-family: "FedraSansStd-book", sans-serif;
                            font-size: 16px;
                            color: #bababa;
                            text-align:left;
                            margin-right:5px;
                            }                          
                          `}
                      </style>
                    </Flex>
                  </Box>
                )}
              </Flex>
              <ContentArea
                pb="0"
                mx="0"
                px="0"
                tAlign="left"
                fontStyle="italic"
                font="16px"
                mainContent={data?.testimonialText}
                region={region}
                lang={lang}
                color="#2d2720 !important"
                fontFamily='"FedraSansStd-book", sans-serif !important'
                className="userText"
              />
            </Box>
          );
        })}
      </Masonry>
      {/* </ResponsiveMasonry> */}

      <style>
        {`
          .userName{
            font-family: "FedraSansStd-medium", sans-serif;
    font-size: 18px;
    color: #1c1c1c;

          }
          .userText em{
            font-family: "FedraSansStd-book", sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: #2d2720;
    font-style: italic !important;
    text-align:left;
    margin:0;
          }
          .userText em{
            font-family: "FedraSansStd-book", sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: #2d2720;
    font-style: italic !important;
    text-align:left;
    margin:0;
          }
          .commentDate{
            margin:5px 0 0 0;
          }
          `}
      </style>
    </Box>
  );
};

export default Testimonial;
/**
 *
 * @param root0
 * @param root0.rating
 * @param root0.region
 * @param root0.lang
 * @param root0.emptyImage
 * @param root0.filledImage
 * @param root0.sectionContent
 */
export function Rating({
  rating,
  emptyImage,
  filledImage,
}) {
  return (
    <>
      <ReactStars
        count={5}
        value={rating.fullstar}
        // onChange={ratingChanged}
        size={24}
        isHalf={true}
        // emptyIcon={<FaBeer />}
        // halfIcon={<FaAlgolia />}
        // filledIcon={<FaTable />}
        emptyIcon={<EmptyIcon src={emptyImage} />}
        halfIcon={<i className="fa fa-star-half-alt"></i>}
        filledIcon={<FilledIcon src={filledImage} />}
        edit={false}
      // char={<FaAccessibleIcon />}
      // activeColor="#ffd700"
      />
    </>
  );
}
